import { AxiosError } from 'axios';
import instance from '../config/axios';
import { ProductBrandResult } from '../interface/interface';

export const getProductBrand = async (
  accessToken: string,
): Promise<Array<ProductBrandResult> | number> => {
  try {
    const response = await instance({
      url: '/api/v1/brands/products',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (e) {
    console.error('Unable to fetch product brands', e);
    return (e as AxiosError).response!.status;
  }
};
